//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/utils/common.js";
import TalksMap from "@/utils/initMapTalks.js";
import * as maptalks from "maptalks";
import regionSeatLibs from '@/utils/regionSeatLibs.js'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  name: "AddSupply",
  data() {
    return {
        TalksMapDialog: new TalksMap(),
        fullscreenLoading:false,
        rules: {
            userLevel: [
            { required: true, message: "请选择划分级别", trigger: "blur" },
            ],
            provinceId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            cityId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            countyId: [
            { required: true, message: "请选择管辖地区", trigger: "change" },
            ],
            userName: [
            { required: true, message: "请填写登录账号", trigger: "blur" },
            { min: 6, max: 20, message: "长度在6到20位", trigger: "blur" },
            { trigger: "blur", validator: common.checkIdAccount },
            ],
            password: [
            { required: true, message: "请填写12-20位账号密码", trigger: "blur" },
            {
                min: 12,
                max: 20,
                message: "请输入12-20位账号密码",
                trigger: "blur",
            },
            { trigger: "blur", validator: common.checkIdPassword },
            ],
            ddCoop: {
              legalPerson: [
              { required: true, message: "请填写法人", trigger: "blur" },
              ],
              creditCode: [
              { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
              ],
              registerAddress: [
              { required: true, message: "请填写注册地址", trigger: "blur" },
              ],
              contactName: [
              { required: true, message: "请填写联系人名称", trigger: "blur" },
              ],
              name: [
              { required: true, message: "请选择供销社", trigger: "blur" },
              ],
              checkedRegionData:{required: true, message: '请选择所在位置', trigger: 'change'},
              address:{ required: true, message: '请点击地图获取位置', trigger: 'change'},
            },
            phone: [
            { required: true, message: "请填写手机号码", trigger: "blur" },
            { validator: common.checkMobile, required: true, trigger: "blur" },
            ],
        },
        form: {
            provinceId: "", //住址省id
            province: "", //住址省name
            cityId: "", //住址市id
            city: "", //住址市name
            countyId: "", //所在地区县id
            county: "", //所在地区县name
            userName: "", // 登陆
            phone: "", // 手机
            password: "", // 密码
            userLevel: 2, // 划分级别
            address:'',//详细地址
            ddCoop:{
              legalPerson:'', // 法人
              creditCode:'', // 统一社会信用代码
              registerAddress:'', // 注册地址
              contactName: "", // 联系人
              name: "", // 供销社名称
              checkedRegionData:[],
              address:''
            }
        },
        
        regionData:regionData,
        regionProps: {
            value: 'i',
            label: 'n',
            children: 'c'
        },
        showPassword: false, // 是否展示密码
        levels: [
            { label: "省级", id: 2 },
            { label: "市级", id: 3 },
            { label: "县级", id: 4 },
        ], // 划分级别列表
        provinceList: [], // 省列表
        cityList: [], // 市列表
        areaList: [], // 区县列表
        loading:false,
    };
  },
  components: {},
  filters: {},
  watch: {
  },
  computed: {
    address() {
      let str;
      switch (this.form.userLevel) {
        case 2:
          str = "provinceId";
          break;
        case 3:
          str = "cityId";
          break;
        case 4:
          str = "countyId";
          break;
      }
      return str;
    },
  },
  created() {
    this.getSelectedCityOptions(1, "provinceList");
  },
  mounted() {
    this.mapInit();
  },
  destroyed() {
    this.map && this.map.removeEventListener('click', this.mapClickAddMaker)
  },
  methods: {
    // 下拉补贴地区选完关闭
    handleRegionChange(val) {
        this.$refs.regionCascader.dropDownVisible = false
        let _params = this.form.ddCoop
        _params.provinceId = val[0] || ''
        _params.cityId = val[1] || ''
        _params.countyId = val[2] || ''
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChangeAddress(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.countyId = "";
          this.cityList = [];
          this.areaList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.countyId = "";
          this.areaList = [];
          list = "cityList";
          break;
        case "":
          list = "areaList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @Description: change级别
     * @Author: yangsibo
     * @Date: 2022-11-09 17:02:09
     * @param {*} val
     * @return {*}
     */
    handleLevel(val) {
      if(val == 1) {
        let _form = this.form
        _form.provinceId = ''
        _form.cityId = ''
        _form.countyId = ''
      }
    },
    /**
     * @Description: 显示/隐藏 密码
     * @Author: yangsibo
     * @Date: 2022-10-14 14:44:54
     * @return {*}
     */
    handleChangePassword(type) {
      this[type] = !this[type];
    },
    /**
     * @Description: 保存县账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:24:38
     * @param {*} formName
     * @return {*}
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          this.addCtCountyAccount();
        } else {
        }
      });
    },
    /**
     * @Description: 添加账号
     * @Author: yangsibo
     * @Date: 2022-09-29 10:44:52
     * @return {*}
     */
    async addCtCountyAccount() {
      let params= {
        ...this.form
      }
      console.log('params==',params)
      try {
        let { status } = await this.$http.supply.supplyMarketAdd(params);
        if (status == 1) {
          this.fullscreenLoading = false
          this.$message.success("添加供销社账号成功");
          this.$router.push({
            path: "/supply/manage/list",
          });
        }
      } catch (error) {
        this.fullscreenLoading = false
        console.log(error);
      }
    },
    /**
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
      mapInit() {
        console.log(window.T);
        const TMap = window.T
        if (this.map) return
        this.map = new TMap.Map('mapDiv')
        this.map.centerAndZoom(new TMap.LngLat(115.546174, 28.054632), 12)
        this.map.addEventListener('click', this.mapClickAddMaker)
      },

      async mapClickAddMaker(e) {
        console.log(e)
        const { lnglat } = e
        const geocoder = new window.T.Geocoder()
        geocoder.getLocation(lnglat, (result) => {
          if (result.getStatus() == 0) {
            const address = result.getAddress()
            this.createMakerWithInfoWindow({
              lonlat: e.lnglat,
              address,
            })
          }
        })
      },
      createMakerWithInfoWindow(addressDetail) {
        this.map && this.map.clearOverLays()
        const { lonlat, address, name } = addressDetail
        const T = window.T
        const icon = new T.Icon({
          iconUrl: require('@/assets/biaozhu_dingwei.png'),
          iconSize: new T.Point(22, 32),
          iconAnchor: new T.Point(10, 25),
        })
        const { lng, lat } = lonlat
        this.form.ddCoop.lng = lng;
        this.form.ddCoop.lat = lat;
        const marker = new T.Marker(new T.LngLat(lng, lat), { icon })
        this.map.addOverLay(marker)
        const addressInfo = name ? `${address}${name}` : address
        this.form.ddCoop.address = addressInfo;
      },
      // mapInit(){
      //   this.TalksMapDialog.sendThis(this);
      //   let center = [115.546174, 28.054632];
      //   let user = JSON.parse(localStorage.getItem("user"));
      //   if (user.lng && user.lat) center =[Number(user.lng),Number(user.lat)];
      //   this.TalksMapDialog.init("mapDiv", 17, center);
      //   this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
      //     this.TalksMapDialog.map
      //   );
      //   // 监听地图点击事件
      //   this.TalksMapDialog.map.on("click", (param) => {
      //     let lng = Number(param.coordinate.x),lat = Number(param.coordinate.y);
      //     this.form.ddCoop.lng = lng;
      //     this.form.ddCoop.lat = lat;
      //     this.markerOnClick(lng,lat);
      //     // this.getAddressByLngLat(lat,lng,(res) => {
      //     //   this.form.address = res.address;
      //     // })
      //   });
      // },
      /**
       * @description: 地图标记点点击事件
       * @param {*}
       * @return {*}
       */    
      // markerOnClick(lng,lat){
      //   this.pic1Marker && this.pic1Marker.clear();
      //   //向地图上添加自定义标注
      //   const marker = new maptalks.Marker(
      //     [lng,lat],
      //     {
      //       symbol: [
      //         {
      //           markerFile: require("@/assets/biaozhu_dingwei.png"),
      //           markerWidth: 22,
      //           markerHeight: 32,
      //           markerOpacity: 1,
      //         },
      //       ],
      //     }
      //   ).addTo(this.pic1Marker);
      // },
      /**
       * @description: 根据经纬度获取详细地址
       * @param {*}
       * @return {*}
       */   
    //   async getAddressByLngLat(lat,lng,fn) {
    //     let coords = lat + "," +lng
    //     let {result} = await geocoder({coords:coords});
    //     fn(result);
    //   },
  },
};
